import { render } from "./manageQtlModal.vue?vue&type=template&id=5a9eda96&scoped=true"
import script from "./manageQtlModal.js?vue&type=script&lang=js"
export * from "./manageQtlModal.js?vue&type=script&lang=js"

import "./manageQtlModal.vue?vue&type=style&index=0&id=5a9eda96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9eda96"]])

export default __exports__